import axios from "axios";

export const syncCartToServer = async (cartItems, token) => {
  const items = cartItems.map((item) => ({
    productId: item._id,
    quantity: item.quantity,
    size: item.selectedSize || undefined,
  }));

  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/cartitems/cart/sync`,
    { items },
    { headers, withCredentials: true }
  );

  return response.data;
};

export const clearServerCart = async (token) => {
  await axios.delete(
    `${process.env.REACT_APP_SERVER_URL}/cartitems/cart/clearallcart`,
    {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    }
  );
};
